import { render, staticRenderFns } from "./ai_common_settings.vue?vue&type=template&id=368b90c3"
import script from "./ai_common_settings.vue?vue&type=script&lang=js"
export * from "./ai_common_settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports